import { Banner, Button, FormLayout, Icon, TextField } from '@shopify/polaris';
import { HideIcon, ViewIcon } from '@shopify/polaris-icons';
import { ErrorBanner } from '@/components';
import { IntegrationAdapter, IntegrationConfig } from '../../types';

interface ConnectionTabProps {
  config: IntegrationConfig;
  adapter: IntegrationAdapter;
}

const ConnectionTab = ({ config, adapter }: ConnectionTabProps) => {
  const panelError = adapter.apiError.create || adapter.apiError.test || adapter.apiError.delete;
  const isConnected = adapter.status === 'active';
  const isLocked = isConnected && !adapter.isEditing;

  return (
    <>
      <ErrorBanner isVisible={!!panelError}>{panelError}</ErrorBanner>

      {adapter.status === 'needs_reconnect' && adapter.reconnectBanner && (
        <Banner tone="critical" title={adapter.reconnectBanner.title}>
          <p>{adapter.reconnectBanner.message}</p>
        </Banner>
      )}

      <FormLayout>
        {(config.fields || []).map((field) => {
          const fieldState = adapter.fields.find((f) => f.key === field.key);
          const showToggle = field.type === 'password' && !isLocked;
          return (
            <TextField
              key={field.key}
              label={field.label}
              id={field.key}
              autoComplete="off"
              disabled={isLocked}
              type={field.type === 'password' && !fieldState?.isShow ? 'password' : 'text'}
              value={fieldState?.value || ''}
              placeholder={isLocked && !fieldState?.value ? '••••••••' : undefined}
              error={fieldState?.error}
              requiredIndicator={!isLocked && field.required !== false}
              helpText={isLocked ? undefined : field.helpText}
              onChange={(value) => adapter.onFieldChange(field.key, value)}
              suffix={
                showToggle ? (
                  <div onClick={() => adapter.onToggleShowSecret(field.key)} style={{ cursor: 'pointer' }}>
                    <Icon source={fieldState?.isShow ? HideIcon : ViewIcon} tone="base" />
                  </div>
                ) : undefined
              }
            />
          );
        })}

        {!isLocked && adapter.onTestConnection && (
          <Button onClick={adapter.onTestConnection} disabled={!adapter.canSave} loading={adapter.isTestingConnection}>
            Test connection
          </Button>
        )}
      </FormLayout>
    </>
  );
};

export default ConnectionTab;
